interface RoundedDiamondProps {
  size?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  filled?: boolean;
  rotation?: number;
  animate?: boolean;
  stacked?: boolean;
  className?: string;
}

export function RoundedDiamond({
  size = 50,
  color = 'primary',
  opacity = 0.42,
  filled = false,
  rotation = 45,
  animate = false,
  stacked = false,
  className = ''
}: RoundedDiamondProps) {
  const colorMap: Record<string, string> = {
    primary: 'var(--color-primary-500)',
    secondary: 'var(--color-secondary-500)',
    accent: '#10B981',
    neutral: '#64748b',
  };

  const borderRadius = size * 0.18;
  const strokeWidth = 2.5;

  const animationStyle = animate ? {
    animation: 'float 12s ease-in-out infinite',
  } : {};

  const viewSize = size * 1.8;
  const center = viewSize / 2;

  return (
    <svg
      width={viewSize}
      height={viewSize}
      viewBox={`0 0 ${viewSize} ${viewSize}`}
      fill="none"
      className={className}
      style={{ opacity, ...animationStyle }}
    >
      <rect
        x={center - size / 2}
        y={center - size / 2}
        width={size}
        height={size}
        rx={borderRadius}
        ry={borderRadius}
        fill={filled ? colorMap[color] : 'none'}
        stroke={filled ? 'none' : colorMap[color]}
        strokeWidth={strokeWidth}
        transform={`rotate(${rotation} ${center} ${center})`}
      />
      {stacked && (
        <>
          <rect
            x={center - size * 0.38}
            y={center - size * 0.38}
            width={size * 0.76}
            height={size * 0.76}
            rx={borderRadius * 0.76}
            ry={borderRadius * 0.76}
            fill="none"
            stroke={colorMap[color]}
            strokeWidth={strokeWidth * 0.75}
            transform={`rotate(${rotation + 12} ${center} ${center})`}
            opacity={0.6}
          />
          <rect
            x={center - size * 0.22}
            y={center - size * 0.22}
            width={size * 0.44}
            height={size * 0.44}
            rx={borderRadius * 0.5}
            ry={borderRadius * 0.5}
            fill="none"
            stroke={colorMap[color]}
            strokeWidth={strokeWidth * 0.5}
            transform={`rotate(${rotation + 24} ${center} ${center})`}
            opacity={0.4}
          />
        </>
      )}
    </svg>
  );
}
